import { render, staticRenderFns } from "./DatesResultsModal.vue?vue&type=template&id=22365e2c"
import script from "./DatesResultsModal.vue?vue&type=script&lang=js"
export * from "./DatesResultsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports